import React, { useEffect, useId, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { getPendingApprovalCount } from '../services/adminService';
import SuperadminModal from './SuperadminModal';

export default function SuperadminButton({ user }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(null);
  const [revision, setRevision] = useState(0);
  const descriptionId = useId();
  useEffect(() => {
    let active = true;
    let pending = false;
    async function refresh() {
      if (pending) return;
      pending = true;
      try {
        const next = await getPendingApprovalCount();
        if (active) setCount(next);
      } catch {
        if (active) setCount(null);
      } finally { pending = false; }
    }
    refresh();
    const timer = window.setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    window.addEventListener('online', refresh);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('online', refresh);
    };
  }, [revision, user.uid]);
  const description = count === null ? 'Pending approval count unavailable' : `${count} pending approval ${count === 1 ? 'request' : 'requests'}`;
  return <>
    <button type="button" className="superadmin-toggle" onClick={() => setOpen(true)} aria-label="Open superadmin" aria-describedby={descriptionId} title={`Superadmin: ${description}`}>
      <ShieldCheck size={16} />
      {count > 0 && <span className="superadmin-badge" aria-hidden="true">{count > 99 ? '99+' : count}</span>}
      <span id={descriptionId} className="sr-only">{description}</span>
    </button>
    {open && <SuperadminModal user={user} onUsersChanged={() => setRevision(value => value + 1)} onClose={() => { setOpen(false); setRevision(value => value + 1); }} />}
  </>;
}
